import { render, staticRenderFns } from "./StoriesMoreSiblingsItemAuthor.vue?vue&type=template&id=08f27d3a&scoped=true&"
import script from "./StoriesMoreSiblingsItemAuthor.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreSiblingsItemAuthor.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreSiblingsItemAuthor.vue?vue&type=style&index=0&id=08f27d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f27d3a",
  null
  
)

export default component.exports